export default __webpack_public_path__ + "d41366313bac155f543d044d531a034a.webp";